module.exports = __webpack_public_path__ + "static/media/register-background.1e599581.jpg";